// About Section Content
export const aboutContent = {
  label: 'About Insite Infra',
  title: 'A Decade of Construction Excellence',
  titleHighlight: 'Excellence',
  paragraphs: [
    'Since 2014, Insite Infra has been delivering Kerala government works and private sector construction projects. With over 20+ successfully completed projects, we have established ourselves as a reliable name in the construction industry across Kerala.',
    "Our experienced team specializes in government infrastructure works and private construction projects, combining proven expertise with modern construction practices. We're committed to delivering quality, timely completion, and building lasting relationships through transparency and dedication.",
  ],
};

// About Features - Core Values
export const aboutFeatures = [
  {
    number: '01',
    title: 'Quality Assurance',
    description: 'Rigorous quality control processes ensuring superior construction standards and long-lasting results.',
  },
  {
    number: '02',
    title: 'Timely Delivery',
    description: 'Committed to meeting project deadlines through efficient planning and resource management.',
  },
  {
    number: '03',
    title: 'Client Satisfaction',
    description: 'Building lasting relationships through transparent communication and exceeding client expectations.',
  },
  {
    number: '04',
    title: 'Safety First',
    description: 'Maintaining the highest safety standards to protect our workforce and stakeholders.',
  },
];

// About Statistics
export const aboutStats = [
  {
    number: '20+',
    label: 'Projects Completed',
  },
  {
    number: '10+',
    label: 'Years Experience',
  },
  {
    number: '50+',
    label: 'Expert Team',
  },
  {
    number: '98%',
    label: 'Client Satisfaction',
  },
];

// About Visual Cards
export const aboutCards = [
  {
    title: 'Government Projects',
    description: 'Specialized in Kerala government works',
  },
  {
    title: 'Proven Experience',
    description: '10+ years of trusted service',
  },
];
